<template>
    <div class="accueil">
        <div class="position-relative w-100 d-flex align-items-center justify-content-center">
            <img src="../assets/img/accueil.jpg" class="w-100" alt="" />

            <div class="cab">
                <Countdown class="d-none d-md-block" :date="end" @onFinish="finish()"></Countdown>
            </div>
        </div>
        <div class="container">
            <Countdown class="my-4 d-sm-block d-md-none phonemode" :date="end" @onFinish="finish()"></Countdown>
            <div class="d-flex justify-content-center">
                <a href="https://forms.gle/GoLukErHRdyYDvs36" target="_blank" class="btn btn-lg btn-primary mt-4 btn-inscription">
                    <span>S'inscrire</span>
                    <i class="fa-solid fa-arrow-up-right-from-square ml-2"></i>
                </a>
            </div>
            <div class="separation"></div>

            <div class="text-primary fs5">
                Les mardi 7 et mercredi 8 février 2023, <span class="text-bold">EDUFOREST France</span> a le plaisir de vous convier à l'EPLEFPA du
                Loiret, Lycée agricole <span class="text-bold">Le Chesnoy</span> pour le
                <u class="text-bold text-underline">1er CONGRES NATIONAL DU PERMIS TRONCONNEUSE !</u>
            </div>
            <div class="my-5 d-flex justify-content-center">
                <table>
                    <tr class="d-flex text-white align-items-center p-3 bg-primary">
                        <td class="text-center"><i class="fa-solid fa-4x fa-xmark mr-4"></i></td>
                        <td>
                            <span class="av85"
                                >Non pas un congrès traditionnel pendant lequel vous écouterez de multiples interventions interminables</span
                            >
                        </td>
                    </tr>
                    <tr class="d-flex text-primary align-items-center p-3">
                        <td class="text-center"><i class="fa-solid fa-4x fa-check mr-4"></i></td>
                        <td><span class="av85">Mais un congrès avec la démonstration d'un réel Permis Tronçonneuse </span></td>
                    </tr>
                    <tr class="d-flex text-white align-items-center p-3 bg-primary">
                        <td class="text-center"><i class="fa-solid fa-4x fa-check mr-4"></i></td>
                        <td><span class="av85">Une "place de marché" sur laquelle vous trouverez tout ce qu'on doit savoir sur ce permis</span></td>
                    </tr>
                    <tr class="d-flex text-primary align-items-center p-3 border-bottom border-primary">
                        <td class="text-center"><i class="fa-solid fa-4x fa-check mr-4"></i></td>
                        <td>
                            <span class="av85">Vous pourrez dialoguer et obtenir les réponses aux questions que vous vous posez certainement</span>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import Countdown from "./Countdown.vue";

export default {
    components: {
        Countdown,
    },
    data() {
        return {
            end: new Date("2023-02-07T00:00:00"),
        };
    },
    methods: {
        finish() {
            console.log("finish");
        },
    },
};
</script>
